// extracted by mini-css-extract-plugin
export default {"separator":"home-card-separator_separator__WKgF+"};